import script from "./MaterialDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialDialog.vue?vue&type=script&setup=true&lang=js"

import "./MaterialDialog.vue?vue&type=style&index=0&id=aad0dfd6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aad0dfd6"]])

export default __exports__